
const TableauBord = function(element, options) {
    this.element  = $(element);
    this.demandes = this.element.find('[data-demandes-url]');
    this.offres = this.element.find('[data-offres-url]');
    this.options = options;

    // Refresh demandes
    this.element.find('[data-create-demande]').on('form-success.modal', () => {
        this.refreshDemandes();
    });
    this.demandes.on('form-success.modal', 'a', () => {
        this.refreshDemandes();
        this.refreshOffres();
    });

    // Refresh offres
    this.element.find('[data-create-offre]').on('form-success.modal', (event, response) => {
        this.refreshOffres();
        this.createCommandeBulk(response.id);
    });
    this.offres.on('form-success.modal', 'a', () => {
        this.refreshOffres();
    });

    // Refresh demandes sur modification d'une vente associée
    this.offres.on('form-success.modal', '[data-vente-demande]', (event) => {
        this.refreshDemande($(event.currentTarget).attr('data-vente-demande'));
    });

    // Refresh offre sur mise à jour des commandes
    this.offres.on('modal-hidden.modal', '[data-liste-commandes]', (event) => {
        this.refreshOffre($(event.currentTarget).closest('[data-offre]').attr('data-offre'));
    });

    this.initDraggables();
    this.initDroppables();

    // Refresh hauteur du tableau
    $(window).on('resize', $.proxy(this.updateSize, this));
    this.updateSize();

    // Effet hover sur les demandes
    this.demandes.on('mouseenter', '.ui-draggable-handle', event => {
        $(event.currentTarget).closest('[data-demande]').addClass('hover');
    });
    this.demandes.on('mouseleave', '.ui-draggable-handle', event => {
        $(event.currentTarget).closest('[data-demande]').removeClass('hover');
    });

    // Gestion du filtrage
    this.defaut = this.options.defaut;
    this.filtreDemandes = $.extend({}, this.options.filtreDemandes);
    this.filtreOffres = $.extend({}, this.options.filtreOffres);

    this.btnFiltreDemandes = $(this.options.button.filterDemandes);
    this.btnFiltreOffres = $(this.options.button.filterOffres);

    this.btnFiltreDemandes.on('form-success.modal', (event, response) => {
        this.updateFiltreDemandes(response);
    });
    this.btnFiltreOffres.on('form-success.modal', (event, response) => {
        this.updateFiltreOffres(response);
    });

    this.semaineDemandes = this.element.find('[data-semaine-courante-demandes]');
    this.semaineOffres   = this.element.find('[data-semaine-courante-offres]');
    this.fournisseursOffres = this.element.find('[data-fournisseurs-format]');
    this.clientsVentes   = this.element.find('[data-clients-format]');

    this.btnRefresh  = $(this.options.button.refresh);
    this.btnRefresh.on('click', $.proxy(this.onRefreshClick, this));

    // Reset filtres
    $(document).on('click', '[data-tdb-reset-demandes]', $.proxy(this.onFiltreDemandesResetClick, this));
    $(document).on('click', '[data-tdb-reset-offres]', $.proxy(this.onFiltreOffresResetClick, this));

    // Toggle demandes
    this.element.find('[data-demandes-toggle]').on('click', $.proxy(this.onDemandesToggle, this));
};

$.extend(TableauBord.prototype, {

    updateSize: function() {
        let height = $(document.body).height() - this.element.offset().top - 15,
            offreHeight = height;

        this.offres.find('.card-heading').each(function() {
            offreHeight -= $(this).height();
        });

        this.element.css('height', height);
        this.demandes.closest('.card').css('height', height);
        this.offres.css('height', offreHeight);
    },

    /**
     * Initialise le D&D des demandes.
     */
    initDraggables: function() {
        /// Drag demandes (vers le tableau des ventes)
        this.demandes.arrive('[data-demande][data-draggable]', {
            existing: true
        }, function() {
            $(this).draggable({
                handle: '.spec',
                helper: function() {
                    const helper = $('<div>', {
                        class: 'drag-helper',
                        html: $(this).html()
                    });

                    helper.find('.buttons').remove();

                    return helper;
                },
                appendTo: this.element,
                cursorAt: { left: 150, top: 60 },
                cursor: 'grabbing'
            });
        });

        /// Drag ventes pour suppression
        this.offres.arrive('[data-vente]', {
            existing: true
        }, function() {
            $(this).draggable({
                handle: '.handle',
                helper: function() {
                    const helper = $('<div>', {
                        class: 'drag-helper',
                        html: $(this).find('.designation').html()
                    });

                    return helper;
                },
                appendTo: this.element,
                cursorAt: { left: 150, top: 30 },
                cursor: 'grabbing'
            })
        });
    },

    initDroppables: function() {
        const onDemandeDrop = $.proxy(this.createVente, this);
        const onVenteDrop = $.proxy(this.deleteVente, this);

        // Drop sur les offres pour créer une vente
        this.offres.arrive('[data-offre]', {
            existing: true
        }, function() {
            $(this).droppable({
                accept: '[data-demande]',
                drop: function(event, ui) {
                    const offre = $(this).attr('data-offre'),
                        demande = ui.draggable.attr('data-demande');

                    onDemandeDrop(offre, demande);
                }
            })
        });

        // Drop sur les demandes pour supprimer une vente
        this.demandes.droppable({
            accept: '[data-vente]',
            drop: function(event, ui) {
                onVenteDrop(ui.draggable.attr('data-vente'));
            }
        });
    },

    createVente: function(offre, demande) {
        const onSuccess = response => {
            if (response.id) {
                this.refreshOffre(offre);
                this.refreshDemande(demande);
            } else if (response.confirm) {
                const modal = new $.fn.ajaxModal.Constructor({
                    content: response.confirm,
                    size: 'large'
                });
                modal.on('form-success.modal', (event, response) => {
                    onSuccess(response);
                })
            }
        };

        $.ajax({
            url: Routing.generate('vente_new'),
            method: 'post',
            data: {
                _token: this.element.attr('data-vente-token'),
                offre: offre,
                demande: demande
            },
            success: response => {
                Notifications.messages(response.messages);

                onSuccess(response);
            }

        });
    },

    deleteVente: function(vente) {
        const $vente = this.offres.find('[data-vente=' + vente + ']');

        $vente.find('[data-delete]').click();
    },

    /**
     * Création automatique des commandes des offres créées
     *
     * @param offres
     */
    createCommandeBulk: function(offres) {
        const modal = new $.fn.ajaxModal.Constructor({
            url: Routing.generate('offre_bulk_commande', {
                id: offres
            })
        });

        modal.on('form-success.modal', () => {
            this.refreshOffre(offres);
            this.refreshDemandes();
        }).show();
    },

    makeFiltreData: function(filtre) {
        const data = $.extend({}, filtre);
        data.periode = undefined;

        return data;
    },

    refreshDemandes: function() {
        this.demandes.find('.preloader-wrapper').removeClass('hidden');

        $.ajax({
            url: this.demandes.attr('data-demandes-url'),
            data: this.makeFiltreData(this.filtreDemandes),
            success: response => {
                this.demandes.html(response);
            }
        })
    },

    refreshDemande: function(demande) {
        this.demandes.find('.preloader-wrapper').removeClass('hidden');

        $.ajax({
            url: Routing.generate('tableau_bord_demande', {
                id: demande
            }),
            success: response => {
                this.demandes.find('[data-demande="' + demande + '"]').replaceWith(response);
                this.demandes.find('.preloader-wrapper').addClass('hidden');
            }
        })
    },

    refreshOffres: function() {
        this.offres.find('.preloader-wrapper').removeClass('hidden');

        $.ajax({
            url: this.offres.attr('data-offres-url'),
            data: this.makeFiltreData(this.filtreOffres),
            success: response => {
                this.offres.html(response);
            }
        })
    },

    refreshOffre: function(offre) {
        this.offres.find('.preloader-wrapper').removeClass('hidden');

        $.ajax({
            url: Routing.generate('tableau_bord_offre', {
                id: offre
            }),
            success: response => {
                this.offres.find('[data-offre="' + offre + '"]').replaceWith(response);
                this.offres.find('.preloader-wrapper').addClass('hidden');
            }
        })
    },

    /**
     * Mise à jour des libellés des semaines.
     */
    refreshFiltres: function() {
        this.semaineDemandes.text(this.filtreDemandes.periode);
        this.semaineOffres.text(this.filtreOffres.periode);
        this.fournisseursOffres.text(this.filtreOffres.fournisseursFormat);
        this.clientsVentes.text(this.filtreOffres.clientsFormat);
    },

    updateFiltreDemandes: function(filtre) {
        this.filtreDemandes = filtre;

        this.refreshDemandes();
        this.refreshFiltres();
    },

    updateFiltreOffres: function(response) {
        this.filtreOffres = response;

        this.refreshOffres();
        this.refreshFiltres();
    },

    onFiltreDemandesResetClick: function(event) {
        this.filtre = $.extend({}, this.defaut);

        $.ajax({
            url: Routing.generate('tableau_bord_reset_filtre_demandes'),
            success: (response) => {
                this.updateFiltreDemandes(response);
            }
        })
    },

    onFiltreOffresResetClick: function(event) {
        this.filtre = $.extend({}, this.defaut);

        $.ajax({
            url: Routing.generate('tableau_bord_reset_filtre_offres'),
            success: (response) => {
                this.updateFiltreOffres(response);
            }
        })
    },

    onRefreshClick: function(event) {
        event.preventDefault();

        this.refreshDemandes();
        this.refreshOffres();
    },

    onDemandesToggle: function() {
        this.element.toggleClass('show-demandes');
    }
});

$.fn.tableauBord = function(options) {
    return $.each(this, function () {
        new TableauBord(this, options);
    })
};


// WEBPACK FOOTER //
// ./js/form/tableauBord.js